import React, { Component } from 'react';
import 'Home/Components/LectureDetails/lecturedetails.css';
import config from 'config';
import HomeApiCall from 'HomeApiCall';
import ButtonLoader from 'Home/CommonResources/ButtonLoader/ButtonLoader';

class LectureDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            academicYear: this.props.academicYear,
            // VARIABLES TO GET LECTURE DETAILS
            fetchingLecture: false,
            lectureDetails: {},
            sorted_session_ids:[],
        };
    }
    
    componentDidMount() {
        // METHOD CALLED TO GET LECTURE DETAILS....
        this.apiCallToGetLectureDetails();
    }

    formatDate = () => {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }

    // API CALL METHOD TO GET LECTURE DETAILS
    apiCallToGetLectureDetails = async () => {
        this.setState({
            fetchingLecture: true
        });

        let requestData = {
            acayr: this.state.academicYear,
            sid: '',
            groupid: '',
            subIdArray: [],
            day: '',
            location: '',
            facultyid: config.faculty_id,
            type: "faculty",
            fromdate: this.formatDate(),
            enddate: this.formatDate()
        };
        

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getDateWiseSessionList',
            requestData,
            '/api/instructor/academicPlaning.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetLectureDetails();
            }, 1000);
        }else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                
                this.setState({
                    lectureDetails: apiResult,
                    fetchingLecture: false,
                    sorted_session_ids:jsonResponse.APIResult.sorted_session_ids,
                });
            }
        }
    }

    render() {
        return (
            <div className="sessionDetails">
                <a href={`${config.RootUrl}/faculty/AcademicPlanningDetails.php`}>
                    <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Today's Lectures</p>
                </a>
                <div className="TodaysLectureList scrollable">
                    {
                        this.state.fetchingLecture ? 
                        <ButtonLoader/>
                        :
                       this.state.sorted_session_ids.length > 0 ? 
                       this.state.sorted_session_ids.map((sessionId,index)=>{
                           let session = this.state.lectureDetails[sessionId];
                            return(
                                <div className={ index % 5 == 0 ? 'zeroIndex sessionDetailsCard' : index % 1 == 0 ? 'firstIndex sessionDetailsCard' : index % 2 == 0 ? 'secondIndex sessionDetailsCard': index % 3 == 0 ? 'thirdIndex sessionDetailsCard': index % 4 == 0 && 'forthIndex sessionDetailsCard' }>
                                    <div className="subjectTitle">{session.subjectName}</div>
                                    <div>{session.ProposedStartTime} - {session.ProposedEndTime}</div>
                                    <div>{session.streamName} | {session.groupName}</div>
                                    
                                </div>
                            )
                       })
                       :<p style={{ fontSize: 12, color: '#818181' }}>Lecture is not planned Yet.</p>
                    }
                </div>
            </div>
        );
    }
}

export default LectureDetails;